/* eslint-disable react/no-unescaped-entities */
import { LIST_TYPE } from "@/shared/types/atoms.types";
import React from "react";
import ListSection from "../atoms/ListSection";
import TermsParagraph from "../atoms/TermsParagraph";

interface PaymentListProps {}
export const paymentListData = [
  {
    index: "(b)",
    description:
      "Referral Rewards will be processed approximately forty-five (45) to seventy (70) days after the end of the month in which they accrue, unless otherwise specifically agreed between You and Graphy in writing (emails included).",
  },
  {
    index: "(c)",
    description:
      "Graphy will only compensate You for Qualified Referrals made in accordance with the terms of these Affiliate Terms and other terms as may be communicated to You in writing (emails included).",
  },
  {
    index: "(d)",
    description:
      "Referral Rewards shall be paid based on the current information provided in Your Affiliate dashboard on the Platform. In case of any changes, it shall be You sole responsibility to update the information in Your dashboard, and Graphy shall not be liable for the same.",
  },
  {
    index: "(e)",
    description:
      "You must have accrued a minimum of $100 (One Hundred US Dollars) or its equivalent in Indian Rupees or such other amount as may be specified on the Platform, for us to disburse Your Referral Rewards.",
  },
  {
    index: "(f)",
    description:
      "Your payment of the Referral Rewards shall be processed only upon Your submission of the required ‘Know Your Customer’ (KYC) documents, relevant invoices, and any other tax related documents as may be required by Graphy.",
  },
  {
    index: "(g)",
    description:
      "In the event you did not provide KYC documents or any other information requested by Graphy, in order to process and disburse the Referral Rewards, within 90 (ninety) days of such request, you will not be eligible to claim the entire amount of Referral Rewards accruing to you. Your eligibility to claim Referral Rewards accruing to you, if any, for a period preceding 90 days from the date you provided adequate details, shall lapse i.e, only Referral Rewards accruing to you in the last 90 (ninety) days shall be considered for any payout to you and Graphy will not be liable for the same.",
  },
  {
    index: "(h)",
    description:
      "It is hereby clarified that the Referral Rewards shall be inclusive of all applicable taxes and subject to deduction of applicable taxes. Graphy shall not be responsible to pay any taxes on the Referral Rewards in any manner.",
  },
  {
    index: "(i)",
    description:
      "Graphy reserves the right to withhold payment of Referral Rewards to Affiliates who have referrals that are in contravention of these Affiliate Terms and/or any terms as may be communicated to You in writing (emails included).",
  },
  {
    index: "(j)",
    description:
      "Graphy reserves the right to immediately cancel or withhold for later review any Referral Rewards that fail to meet the criteria of a “Qualified Referral”. You are responsible for monitoring the payment, denial, and withholding of Referral rewards; Graphy is not obligated to actively notify You of the status of the Referral Rewards. If Affiliate has a question about a Referral Reward that has been cancelled or withheld, Affiliate has thirty (30) days from the day the payment would have been due to contact Graphy to request that the Referral Reward be paid. Any changes to decisions about cancelled or withheld Referral Reward are strictly made in Graphy’s sole discretion.",
  },
];

const PaymentList: React.FC<PaymentListProps> = () => {
  return (
    <div>
      <ListSection
        listIndex="4.1."
        title="Referral Rewards:"
        listType={LIST_TYPE.LIST2}
      />

      <ListSection
        listIndex="(a)"
        listType={LIST_TYPE.LIST3}
        description={
          <TermsParagraph>
            You will be entitled to receive a commission from Graphy for every
            Qualified Referral, i.e., when Your Referred User has successfully
            purchased a subscription plan on the Platform, You will be entitled
            to receive a commission from Graphy <b>(“Referral Rewards”)</b>; a
            ‘successful purchase of a subscription plan on the Platform’ shall
            mean when Graphy has received the payment from the Qualified,
            without any cancellations or refund claims.
            <br />
            <br />
            Any failure on Your part to display, share or link the correct
            Referral Link shall not be the responsibility of Graphy.
          </TermsParagraph>
        }
      />

      <ListSection
        listIndex="(b)"
        listType={LIST_TYPE.LIST3}
        description={
          <TermsParagraph>
            The <b>percentage of the Referral Rewards</b> shall be as specified
            on the Platform at{" "}
            <a href="https://partners.ongraphy.com/">
              https://partners.ongraphy.com/
            </a>{" "}
            and/or as communicated to You in writing by Graphy (emails
            included).
          </TermsParagraph>
        }
      />

      <ListSection
        listIndex="(b)"
        listType={LIST_TYPE.LIST3}
        description="The duration for which these Referral Rewards are offered, are as detailed out on the Platform and/or as communicated to You in writing (emails included). The Referral Rewards may vary from time to time at Graphy’s sole discretion, unless otherwise specifically communicated to You in writing (emails included)."
      />

      <ListSection
        listIndex="4.2."
        title="Payment:"
        listType={LIST_TYPE.LIST2}
      />

      <TermsParagraph className="ml-4 md:ml-16">
        As stated above, for every Qualified Referral You shall be entitled to
        Referral Rewards. As stated above, we may track the Qualified Referrals
        generated by You through Your Referral Link using the Affiliate Platform
        and will make this information available to You on Your Affiliate
        dashboard on the Platform. To permit accurate tracking, reporting, and
        commission accrual, You must ensure that the Referral Links are properly
        formatted and made available to Your customers/users.
      </TermsParagraph>

      <ListSection
        listIndex="(a)"
        listType={LIST_TYPE.LIST3}
        description={
          <TermsParagraph>
            Referral Rewards will be calculated based on the percentage
            specified on the Platform at{" "}
            <a href="https://partners.ongraphy.com/">
              https://partners.ongraphy.com/
            </a>{" "}
            and/or as communicated to You in writing by Graphy (emails
            included), subject to these Affiliate Terms.
          </TermsParagraph>
        }
      />

      {paymentListData.map((paymentData) => (
        <React.Fragment key={paymentData.index}>
          <ListSection
            listIndex={paymentData.index}
            listType={LIST_TYPE.LIST3}
            description={paymentData.description}
          />
        </React.Fragment>
      ))}

      <ListSection
        listIndex="4.3."
        title="IP Licenses and Use:"
        listType={LIST_TYPE.LIST2}
      />

      <TermsParagraph className="ml-4 md:ml-16">
        Subject to the limitations set forth in these Affiliate Terms, we grant
        You a non-exclusive, non-transferable, non-assignable, revocable license
        to (i) provide access to Graphy’s website through the Referral Links
        solely in accordance with these Affiliate Terms; and (ii) use Graphy’s
        IP for the sole purpose of promoting Graphy’s Services in accordance
        with these Affiliate Terms and/or any terms as may be communicated to
        You in writing (emails included).
      </TermsParagraph>
      <TermsParagraph className="ml-4 md:ml-16">
        You may not alter, modify, or change Graphy’s IP in any way or use
        Graphy’s IP in any manner that is disparaging or that otherwise portrays
        Graphy, any Graphy employee, representative or customer in a negative
        light. You are only entitled to use Graphy’s IP in compliance with the
        terms of these Affiliate Terms, Platform Terms and/or any terms as may
        be communicated to You in writing (emails included).
      </TermsParagraph>
      <TermsParagraph className="ml-4 md:ml-16">
        Your license to use Graphy’s IP shall immediately terminate upon the
        termination of Your participation in the Affiliate Program for any
        reason. We reserve all of our rights in Graphy’s IP and Your license to
        use Graphy’s IP is limited to the manner described herein.
      </TermsParagraph>
    </div>
  );
};

PaymentList.displayName = "PaymentList";

export default PaymentList;
